import { preLoad } from "./include/module";
import { anchorLink } from "./include/module";
import { scrollAnime } from "./include/module";
import { loadedAnime } from "./include/module";
import { resizeHeader } from "./include/module";
import { toggleNav } from "./include/module";
import { scrollMv } from "./include/module";
import { customScroll } from "./include/module";





(() => {

  preLoad();
  anchorLink();
  scrollAnime();
  loadedAnime();
  resizeHeader();
  toggleNav();
  // customScroll();
  // scrollMv();

})();

// particle
particlesJS('particles-01',{
  "particles":{

      "number":{
        "value":30,
        "density":{
          "enable":true,
          "value_area":800
        }
      },
      "shape":{
        "type":["image"],
        "image": {
          "src": "./assets/js/images/icon_kira.png",
          "width": 54,
          "height": 56
        }
      },
      "color":{
        "value":"#ffffff"
      },
      "size":{
        "value":20,
        "random":true,
        "anim":{
          "enable":true,
          "speed":20,
          "size_min":10,
          "sync":false
        }
      },
      "line_linked":{
        "enable":false,
      },
      "move":{
        "speed":0.4,
        "straight":false,
        "out_mode":"bounce"
      }
    },

    "interactivity":{
      "detect_on":"canvas",
      "events":{
        "onhover":{
          "enable":false,
          "mode":"repulse"
        },
        "onclick":{
          "enable":true,
          "mode":"push"
        },
      },

      "modes":{
        "push":{
          "particles_nb":1
        },
        "remove":{
          "particles_nb":2
        }
      }
    },
    "retina_detect":true,
    "resize":true
  }
);



// WEBPACK FOOTER //
// ./src/assets/js/script.js